import { FormControl, Grid, IconButton, InputLabel, Select, TextField
    , Typography, Stack, Box, Checkbox, FormControlLabel } from '@mui/material';
import { Search as IconSearch } from "@mui/icons-material";
import api from "../services/api";
import moment from 'moment';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { init, setEntity, setData, setValidationMessage, activeValidations, defaultEntity } from "../redux/skillSlice";
import { FormHelperText as HelperText } from '@mui/material';

const Skill = (props) => {
    const isReadOnly = props.isReadOnly;
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const inputRef = useRef(null);

    useEffect(() => {
        dispatch(init({ sliceKey }));
    }, [dispatch, sliceKey]);

    useEffect(() => {
        if (props.autoFocus) {
        const timer = setTimeout(() => inputRef.current?.focus(), 150);
        return () => clearTimeout(timer);
        }
    }, [props.autoFocus]);

    const entity = useSelector((state) => state.skill[sliceKey]?.entity);
    const validate = useSelector((state) => state.skill[sliceKey]?.validationActive);

    var validation = {
        codigo: {
            error: entity?.codigo.length < 1,
            message: "Falta ingresar el codigo de la destreza",
        },
        nombre: {
            error: entity?.nombre.length < 1,
            message: "Falta ingresar el nombre de la destreza",
        },
    }

    const fetchEntity = useCallback(async () => {
        const response = await api.get("/Modelo/GetDestreza?idDestreza=" + props.id)
            .catch((err) => {
                console.log("Err: ", err);
            });

        if (props.id == 0 || props.id == null){
            dispatch(setEntity({sliceKey: sliceKey, data: defaultEntity}));
        }
        else {
            dispatch(setEntity({sliceKey: sliceKey, data: response.data.data}));
        }
    }, [])

    useEffect(() => {
        fetchEntity();
        dispatch(setValidationMessage({sliceKey: sliceKey, message: messagesValidation()}));
    }, []);

    useEffect(() => {
        dispatch(setValidationMessage({sliceKey: sliceKey, message: messagesValidation()}));
    }, [entity])

    var setDataEntity = e => {
        dispatch(setData({sliceKey: sliceKey, name: e.target.name, value: e.target.value}));
    }

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    return (
        <Grid container>
            {/* {JSON.stringify(validation)}
            {JSON.stringify(validate)} */}
            {/* {JSON.stringify(entity)} */}
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={4} sm={3}>
                    <TextField
                        required
                        name="codigo"
                        label="Codigo"
                        fullWidth
                        value={entity?.codigo}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={9}>
                    <TextField
                        name="nombre"
                        label="Nombre"
                        fullWidth
                        value={entity?.nombre}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={3} sm={6}>
                    <TextField
                        name="edadMesesInicio"
                        label="Meses Inicio"
                        type='number'
                        fullWidth
                        value={entity?.edadMesesInicio}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={3} sm={6}>
                    <TextField
                        name="edadMesesFin"
                        label="Meses Fin"
                        type='number'
                        fullWidth
                        value={entity?.edadMesesFin}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <TextField
                        name="descripcion"
                        label="Descripción"
                        fullWidth
                        value={entity?.descripcion}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}
export default Skill;
